module.exports = __webpack_public_path__ + "media/G_.c943c0c7.mp3";